// extracted by mini-css-extract-plugin
export var container = "community-curation-module--container--H-N7m";